export default __webpack_public_path__ + "static/media/17.37b99f63.png";